@use 'noselect';
@use 'fontsmoothing';

[data-player] {
  @include noselect.no-select;
  @include fontsmoothing.font-smoothing;
  transform: translate3d(0,0,0);
  position: relative;
  margin: 0;
  padding: 0;
  border: 0;
  font-style: normal;
  font-weight: normal;
  text-align: center;
  overflow: hidden;
  font-size: 100%;
  font-family: "Roboto", "Open Sans", Arial, sans-serif;
  text-shadow: 0 0 0;
  box-sizing: border-box;

  &:focus {
    outline: 0;
  }

  * {
    box-sizing: inherit;
  }

  > * {
    float: none;
    max-width: none;
  }

  > div {
    display: block;
  }

  &.fullscreen {
    width: 100% !important;
    height: 100% !important;
    top: 0;
    left: 0;
  }

  &.nocursor {
    cursor: none;
  }
}

.clappr-style {
  display: none !important;
}
